import React, { Fragment, useState } from "react";
import { Dialog, Popover, Transition } from "@headlessui/react";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonThird from "shared/Button/ButtonThird";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import Checkbox from "shared/Checkbox/Checkbox";
import Slider from "rc-slider";
import convertNumbThousand from "utils/convertNumbThousand";
import { ISelectedFiltersHotelList } from "./SectionGridHasMap";

const TabFilters: React.FC<{
  filters?: {
    amenities: {},
    arrangement: {},
    prices: number[]
  },
  selectedFilters?: ISelectedFiltersHotelList,
  setSelectedFilters?: (data: ISelectedFiltersHotelList) => void
}> = ({ filters, selectedFilters, setSelectedFilters }) => {
  const [isOpenMoreFilterMobile, setisOpenMoreFilterMobile] = useState(false);

  const closeModalMoreFilterMobile = () => setisOpenMoreFilterMobile(false);
  const openModalMoreFilterMobile = () => setisOpenMoreFilterMobile(true);

  const renderXClear = () => {
    return (
      <span className="w-4 h-4 rounded-full bg-primary-500 text-white flex items-center justify-center ml-3 cursor-pointer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-3 w-3"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </span>
    );
  };


  const onChangeMoreFilterItem = (filterKey: "amenities" | "arrangement", key: string) => (checked: boolean) => {

    if (!checked) {
      setSelectedFilters && setSelectedFilters({
        ...selectedFilters!,
        [filterKey]: selectedFilters![filterKey].filter(el => el !== key)
      })
    } else {
      setSelectedFilters && setSelectedFilters({
        ...selectedFilters!,
        [filterKey]: selectedFilters![filterKey].concat(key)
      })
    }

  }

  const renderMoreFilterItem = (
    data: { [key: string]: string },
    filterKey: "amenities" | "arrangement"
  ) => {
    const list1 = Object.entries(data).filter((_, i) => i < Object.entries(data).length / 2);
    const list2 = Object.entries(data).filter((_, i) => i >= Object.entries(data).length / 2);
    return (
      <div className="grid grid-cols-2 gap-8">
        <div className="flex flex-col space-y-5">
          {list1.map(([key, label]) => (
            <Checkbox
              key={key}
              name={label + key.trim()}
              label={label}
              onChange={onChangeMoreFilterItem(filterKey, key)}
              checked={selectedFilters![filterKey].includes(key)}
            />
          ))}
        </div>
        <div className="flex flex-col space-y-5">
          {list2.map(([key, label]) => (
            <Checkbox
              key={key}
              name={label + key.trim()}
              label={label}
              onChange={onChangeMoreFilterItem(filterKey, key)}
              checked={selectedFilters![filterKey].includes(key)}
            />
          ))}
        </div>
      </div>
    );
  };


  const renderTabMoreFilterMobile = () => {
    return (
      <div className="mb-3" >
        <div
          className={`flex lg:hidden items-center justify-center px-4 py-2 text-sm rounded-full border border-primary-500 bg-primary-50 text-primary-700 focus:outline-none cursor-pointer`}
          onClick={openModalMoreFilterMobile}
        >
          <span>More filters</span>
          {renderXClear()}
        </div>

        <Transition appear show={isOpenMoreFilterMobile} as={Fragment}>
          <Dialog
            as="div"
            className="fixed inset-0 z-50 overflow-y-auto"
            onClose={closeModalMoreFilterMobile}
          >
            <div className="min-h-screen text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40 dark:bg-opacity-60" />
              </Transition.Child>

              {/* This element is to trick the browser into centering the modal contents. */}
              <span
                className="inline-block h-screen align-middle"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                className="inline-block py-8 px-2 h-screen w-full max-w-4xl"
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <div className="inline-flex flex-col w-full max-w-4xl text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 dark:text-neutral-100 shadow-xl h-full">
                  <div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-primary-gray text-center">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      Plus de filtres
                    </Dialog.Title>
                    <span className="absolute left-3 top-3">
                      <ButtonClose onClick={closeModalMoreFilterMobile} />
                    </span>
                  </div>

                  <div className="flex-grow overflow-y-auto">
                    <div className="px-4 sm:px-6 divide-y divide-neutral-200 dark:divide-primary-gray">
                      {/* ---- */}
                      <div className="py-7">
                        <h3 className="text-xl font-medium">Services & équipements</h3>
                        <div className="mt-6 relative ">
                          {renderMoreFilterItem(filters!.amenities, "amenities")}
                        </div>
                      </div>
                      {/* ---- */}
                      <div className="py-7">
                        <h3 className="text-xl font-medium">Arrangement</h3>
                        <div className="mt-6 relative ">
                          {renderMoreFilterItem(filters!.arrangement, "arrangement")}
                        </div>
                      </div>

                      {/* ---- */}
                      <div className="py-7">
                        <h3 className="text-xl font-medium">Prix</h3>
                        <div className="mt-6 relative ">
                          <div className="relative flex flex-col space-y-8">
                            <div className="space-y-5">
                              <Slider
                                range
                                className="text-red-400"
                                min={filters!.prices[0]}
                                max={filters!.prices[1]}
                                value={[selectedFilters!.rangePrices[0] || filters!.prices[0], selectedFilters!.rangePrices[1] || filters!.prices[1]]}
                                allowCross={false}
                                onChange={(e) => setSelectedFilters && setSelectedFilters({ ...selectedFilters!, rangePrices: e as [number, number] })}
                              />
                            </div>

                            <div className="flex justify-between space-x-5">
                              <div>
                                <label
                                  htmlFor="minPrice"
                                  className="block text-sm font-medium text-neutral-700 dark:text-neutral-300"
                                >
                                  Min price
                                </label>
                                <div className="mt-1 relative rounded-md">
                                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <span className="text-neutral-500 sm:text-sm">
                                      $
                                    </span>
                                  </div>
                                  <input
                                    type="text"
                                    name="minPrice"
                                    disabled
                                    id="minPrice"
                                    className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-3 sm:text-sm border-neutral-200 rounded-full text-neutral-black "
                                    value={selectedFilters!.rangePrices[0] || filters!.prices[0]}
                                  />
                                </div>
                              </div>
                              <div>
                                <label
                                  htmlFor="maxPrice"
                                  className="block text-sm font-medium text-neutral-700 dark:text-neutral-300"
                                >
                                  Max price
                                </label>
                                <div className="mt-1 relative rounded-md">
                                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <span className="text-neutral-500 sm:text-sm">
                                      $
                                    </span>
                                  </div>
                                  <input
                                    type="text"
                                    disabled
                                    name="maxPrice"
                                    id="maxPrice"
                                    className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-3 sm:text-sm border-neutral-200 rounded-full text-neutral-black "
                                    value={selectedFilters!.rangePrices[1] || filters!.prices[1]}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* ---- */}
                      <div className="py-2">
                        <div className="mt-6 relative ">
                          <Checkbox
                            name={"Annulationgratuite"}
                            label={"Annulation gratuite"}
                            checked={selectedFilters!.freeCancellation}
                            onChange={checked => setSelectedFilters && setSelectedFilters({ ...selectedFilters!, freeCancellation: checked })}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="p-4 sm:p-6 flex-shrink-0 bg-neutral-50 dark:bg-neutral-900 dark:border-t dark:border-primary-gray flex items-center justify-between">
                    <ButtonThird
                      onClick={() => {
                        closeModalMoreFilterMobile()
                        setSelectedFilters && setSelectedFilters({
                          amenities: [],
                          arrangement: [],
                          freeCancellation: false,
                          rangePrices: [filters!.prices[0], filters!.prices[1]],
                        })
                      }}
                      sizeClass="px-4 py-2 sm:px-5"
                    >
                      Clear
                    </ButtonThird>
                    <ButtonPrimary
                      onClick={closeModalMoreFilterMobile}
                      sizeClass="px-4 py-2 sm:px-5"
                    >
                      Apply
                    </ButtonPrimary>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>
      </div>
    );
  };

  return (
    <div className=" w-full">
      {renderTabMoreFilterMobile()}
    </div>
  );
};

export default TabFilters;
